import PersistStorage from "modules/utils/PersistStorage";
import {nanoid} from "nanoid";

export const getUserUuid = () => {
	const userUuid = PersistStorage.GET("userUuid");

	if (userUuid) {
		return userUuid;
	} else {
		const newUserUuid = nanoid();
		PersistStorage.SET("userUuid", newUserUuid);

		return newUserUuid;
	}
};
